/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Header as VaiHeader, Heading, Button, Icon, ButtonType, Size } from '@vaisala/rockhopper-components';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { useTranslation } from 'react-i18next';
import { Hidden, Visible, useScreenClass } from 'react-grid-system';
import LanguageController from '../modules/LanguageController';
import './Header.scss';

interface HeaderProps {
  title: string;
  unitOptions: string[];
  unitIndex: number;
  onChooseUnit: (ind: number) => void;
  toggleTheme: VoidFunction;
  onMobileMenuOpen: VoidFunction;
  onHelpOpen: VoidFunction;
  showPWAButton: boolean;
  onShowPWAPrompt: VoidFunction;
}

// eslint-disable-next-line
const Link = (props: any) => (
  <a href="#" {...props}>
    {props.children}
  </a>
);

export const Header = ({
  toggleTheme,
  title,
  unitOptions,
  unitIndex,
  onChooseUnit,
  onMobileMenuOpen,
  onHelpOpen,
  showPWAButton,
  onShowPWAPrompt,
}: HeaderProps) => {
  const { t } = useTranslation();
  const screenClass = useScreenClass();
  const isMobile = () => ['xs', 'sm'].includes(screenClass);

  return (
    <VaiHeader className="header" logoVisible={true} title={t(title)}>
      <Hidden xs sm>
        {/* <div>
          <Heading className="custom-header" level={1}>{t(title)}</Heading>
        </div> */}

        {showPWAButton && (
          <Button buttonType={ButtonType.Secondary} buttonSize={Size.M} startIcon={<Icon name={VaiIcon.Download} />} onClick={onShowPWAPrompt}>
            {t('ui.install')}
          </Button>
        )}

        <VaiHeader.Item startIcon={<Icon name={VaiIcon.Help} />} onClick={onHelpOpen} title={t('ui.help')} />
        {/* <VaiHeader.Menu startIcon={<Icon name={VaiIcon.FilterSwitches}/>} title={t('ui.units')}>
          {unitOptions.map((option, i) => (
            <VaiHeader.MenuItem key={i} component={Link}
              startIcon={i===unitIndex ? <Icon name={VaiIcon.Check}/> : undefined}
              onClick={() => onChooseUnit(i)}>
              {t(option)}
            </VaiHeader.MenuItem>
          ))}
        </VaiHeader.Menu> */}
        <VaiHeader.Item startIcon={<Icon name={VaiIcon.Contrast} />} onClick={toggleTheme} title={t('ui.theme')} />
      </Hidden>
      <VaiHeader.Menu
        startIcon={isMobile() ? undefined : <Icon name={VaiIcon.Language} />}
        title={isMobile() ? LanguageController.currentLanguageNameShort : LanguageController.currentLanguageName}
      >
        {LanguageController.languages.map((lng, i) => (
          <VaiHeader.MenuItem
            key={i}
            component={Link}
            startIcon={LanguageController.isCurrentLanguage(lng) ? <Icon name={VaiIcon.Check} /> : undefined}
            onClick={() => LanguageController.changeLanguage(lng)}
          >
            {LanguageController.languageName(lng)}
          </VaiHeader.MenuItem>
        ))}
      </VaiHeader.Menu>
      <Visible xs sm>
        <VaiHeader.Item startIcon={<Icon name={VaiIcon.MobileMenu} />} onClick={onMobileMenuOpen} />
      </Visible>
    </VaiHeader>
  );
};
